<agr-page-toolbar
  [pageTitle]="'nutrientProperties.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'nutrientProperties.addNutrientProperty' | translate"
  (primaryAction)="createNutrientProperty()"
>
  <div class="container">
    <agr-notification-empty
      [isEmpty]="!dataAvailable"
      [emptyDescription]="'nutrientProperties.nutrientPropertiesEmpty' | translate"
      emptyActionIcon="clear"
    >
      <mat-table [dataSource]="dataSource" data-test="nutrient-property-table">
        <ng-container matColumnDef="source">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.source' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.source }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nutrientDesignation">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.nutrientDesignation' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.nutrientDesignation }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilType">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.soilType' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilType.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="sampleNumber">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.sampleNumber.title' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            `nutrientProperties.sampleNumber.${item.sampleNumber}` | translate
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilTargetLow">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.soilTargetLow' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilTargetLow }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilTargetHigh">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.soilTargetHigh' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilTargetHigh }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilTargetUoM">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.soilTargetUoM' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilTargetUoM }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="plantTargetLow">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.plantTargetLow' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.plantTargetLow }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="plantTargetHigh">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.plantTargetHigh' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.plantTargetHigh }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="plantTargetUoM">
          <mat-header-cell *matHeaderCellDef>{{
            'nutrientProperties.plantTargetUoM' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.plantTargetUoM }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2"></mat-header-cell>
          <mat-cell *matCellDef="let item" class="flex--justify-end flex__child flex__child-2">
            <agr-responsive-actions
              [items]="nutrientPropertyActions"
              [showLabels]="false"
              (action)="nutrientPropertyAction($event, item.id)"
            ></agr-responsive-actions>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          data-test="nutrient-property-row"
        ></mat-row>
      </mat-table>
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
